export const eligibleHeaders = [
  {
    text: "Loc. Code",
    value: "location_code"
  },
  {
    text: "Customer Name",
    value: "recipient_name"
  },
  {
    text: "Tenant ID",
    value: "tenant_id"
  },
  {
    text: "Quoted Price",
    value: "rent_rate"
  },
  {
    text: "GC Amount",
    value: "card_amount"
  },
  {
    text: "Move-In Date",
    value: "move_in_date"
  },
  {
    text: "Eligible On",
    value: "eligible_at"
  },
  {
    text: "Actions...",
    sortable: false
  }
];
export const issuedHeaders = [
  {
    text: "Loc. Code",
    value: "location_code",
    width: "6.5rem"
  },
  {
    text: "Customer Name",
    value: "recipient_name",
    width: "15rem"
  },
  {
    text: "Tenant ID",
    value: "tenant_id",
    width: "7rem"
  },
  {
    text: "Quoted Price",
    value: "rent_rate",
    width: "8rem"
  },
  {
    text: "GC Amount",
    value: "card_amount",
    width: "7rem"
  },
  {
    text: "Move-In Date",
    value: "move_in_date",
    width: "10rem"
  },
  {
    text: "Issue Date",
    value: "issued_at",
    width: "10rem"
  },
  {
    text: "Status",
    value: "reward_status",
    width: "6.5rem"
  },
  {
    text: "Confirmation #",
    value: "confirmation_number",
    width: "13rem"
  },
  {
    text: "Notes",
    value: "notes",
    width: "18rem"
  },
  {
    text: "Actions...",
    sortable: false
  }
];
